import React from 'react';
import scenarioViewEdit from '../../forms/scenarioViewEdit';
import Form from '../Form';
import { ModalButton } from './styles';

const ScenarioViewEditModal = ({ onSubmit, defaultData, onClickToViewScenario }) => (
  <>
    <Form
      scaffold={scenarioViewEdit(defaultData)}
      onSubmit={(formData, actions) => onSubmit(formData, actions, true)}
      isSubmitting
      enableReinitialize
      actions={({ submitForm, isSubmitting, values }) => (
        <>
          <ModalButton
            type="primary"
            onClick={submitForm}
            disabled={isSubmitting}
          >
            Update
          </ModalButton>

          <ModalButton
            onClick={() => onClickToViewScenario(values, true)}
            disabled={isSubmitting}
          >
            View dashboard
          </ModalButton>

          <ModalButton
            onClick={() => onClickToViewScenario(values, false)}
            disabled={isSubmitting}
          >
            View data
          </ModalButton>
        </>
      )}
    />
  </>
);


export default ScenarioViewEditModal;
